import { render, staticRenderFns } from "./BulkCreateProduct.vue?vue&type=template&id=13fe1a6e&scoped=true&"
import script from "./BulkCreateProduct.vue?vue&type=script&lang=js&"
export * from "./BulkCreateProduct.vue?vue&type=script&lang=js&"
import style0 from "./BulkCreateProduct.vue?vue&type=style&index=0&id=13fe1a6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13fe1a6e",
  null
  
)

export default component.exports